import { useContext } from 'react';
import { useStore } from 'zustand';

import { type AuditState, AuditStoreContext } from '@/contexts/AuditStoreProvider';

export const useAuditStore = <T>(selector: (state: AuditState) => T) => {
  const store = useContext(AuditStoreContext);
  if (!store) {
    throw new Error('useAuditStore must be used within an AuditStoreProvider');
  }

  return useStore(store, selector);
};
